import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import toast from 'react-hot-toast';
import * as Yup from "yup";
import useCustomValidation from '../../../hooks/useCustomValidation';
import useLogout from '../../../hooks/useLogout';
import ValidationError from '../../ValidationError';
import RegexInput from '../../RegexInput';


function UpdateUPIModal({ updateData, show, handleClose }) {
    const logoutUser = useLogout();

    const [isLoading, setIsLoading] = useState(false);
    const [upiActiveStatus, setUpiActiveStatus] = useState(null);
    const [regexStatus, setRegexStatus] = useState(null);
    const [staticQrCode, setStaticQrCode] = useState(null);
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

    const schema = {
        upi: Yup.string().required("UPI is required"),
        merchant: Yup.string().required("Merchant is required"),
        name: Yup.string().required("UPI Name is required").trim(),
        vpa: Yup.string().required("UPI Id is required").trim(),
        isRegex: Yup.bool().required("Is Regex Enabled is required"),
        regexPattern: Yup.string().trim(),
        staticQrCode: Yup.bool().required("Qr Code is required"),
        qrCodeImage: Yup
            .mixed()
            .nullable()
            .when('staticQrCode', {
                is: true,
                then: (schema) =>
                    schema.test(
                        "required-if-static",
                        "QR Code image is required",
                        (value) => {
                            // console.log("value", value)
                            if (!value) return false;

                            // Case 1: It's a file
                            if (typeof value === "object" && value instanceof File) return true;

                            // Case 2: It's a string URL
                            if (typeof value === "string" && value.trim().length > 0) return true;

                            return false;
                        }
                    ).test(
                        "fileSize",
                        "File is too large (max 5MB)",
                        (value) => {
                            if (value instanceof File) {
                                return value.size <= 5 * 1024 * 1024;
                            }
                            return true; // Skip for string URLs
                        }
                    ).test(
                        "fileType",
                        "Invalid file type",
                        (value) => {
                            if (value instanceof File) {
                                return ["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(value.type);
                            }
                            return true; // Skip for string URLs
                        }
                    ),
                otherwise: (schema) => schema.notRequired(),
            }),
        // .when('staticQrCode', {
        //     is: true, // Condition: if 'staticQrCode' is true
        //     then: (schema) =>
        //         schema
        //             // .test("required", "QR Code image is required", (value) => {
        //             //     return value && value.length > 0;
        //             // })
        //             .required("QR Code image is required1")
        //             .test(
        //                 'fileSize',
        //                 'File is too large (max 5MB)',
        //                 (value) => !value || !value[0] || typeof value[0].size !== "number" || value[0].size <= 5 * 1024 * 1024// 5MB
        //             )
        //             .test(
        //                 'fileType',
        //                 'Invalid file type (only .jpg, .png, .webp)',
        //                 (value) =>
        //                     !value ||
        //                     !value[0] ||
        //                     ["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(value[0].type)
        //             ),
        //     otherwise: (schema) => schema.notRequired(), // Otherwise, it's not required
        // }),
        enabled: Yup.bool().required("Active is required"),
    };
    const initial = {
        upi: null,
        merchant: null,
        name: null,
        vpa: null,
        isRegex: false,
        regexPattern: "",
        staticQrCode: false,
        qrCodeImage: null,
        enabled: null,
    };
    const { register, errors, handleSubmit, reset, getValues, setValue } =
        useCustomValidation({ schema, initial });


    useEffect(() => {
        // console.log(updateData)
        setValue("upi", updateData.upi)
        setValue("merchant", updateData.merchant)
        setValue("name", updateData.name)
        setValue("vpa", updateData.vpa)
        setValue("isRegex", updateData.isRegex)
        setRegexStatus(updateData.isRegex)
        setValue("regexPattern", updateData.regexPattern)
        setValue("enabled", updateData.enabled)
        setStaticQrCode(updateData.staticQrCode)
        setValue("staticQrCode", updateData.staticQrCode)
        setValue("qrCodeImage", updateData.qrCodePath)
        if (updateData.qrCodePath) {
            setImagePreviewUrl(`https://pagoassets.s3.eu-west-2.amazonaws.com/${updateData.qrCodePath}`)
        }
        setUpiActiveStatus(updateData.enabled)

        return () => { }
    }, [updateData])

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // console.log("file ", file)
        if (file) {
            setImagePreviewUrl(URL.createObjectURL(file));
            setValue("qrCodeImage", file); // ✅ Store just the file
        } else {
            setValue("qrCodeImage", null); // ✅ Clear if removed
            setImagePreviewUrl(null);
        }
    };

    const toggleStaticQrCode = () => {
        const status = getValues("staticQrCode")
        setValue("staticQrCode", !status)
        setStaticQrCode(!status)
    }

    const toggleRegexStatus = () => {
        const status = getValues("isRegex")
        setValue("isRegex", !status)
        setRegexStatus(!status)
    }

    const toggleActive = () => {
        const status = getValues("enabled")
        setValue("enabled", !status)
        setUpiActiveStatus(!status)
    }

    const updateUpiSubmit = async (data) => {
        // console.log(data)
        setIsLoading(true)

        const formData = new FormData();
        // console.log("typeof (data.qrCodeImage)", typeof (data.qrCodeImage), data.qrCodeImage)
        if (typeof (data.qrCodeImage) == "string") {
            formData.append("qrCodeImage", data.qrCodeImage);
        } else {
            formData.append("qrCodeImage", data.qrCodeImage);
        } formData.append("enabled", data.enabled);
        formData.append("isRegex", data.isRegex);
        formData.append("merchant", updateData.merchant);
        formData.append("name", data.name);
        formData.append("regexPattern", data.regexPattern);
        formData.append("staticQrCode", data.staticQrCode);
        formData.append("upi", data.upi);
        formData.append("vpa", data.vpa);

        await axios
            .put(`${process.env.REACT_APP_API_URL}/merchant/upi/update`,
                formData)
            .then((response) => {
                const { data } = response;
                if (response.status == 200) {
                    toast.success(data.msg);
                    reset()
                    handleClose("success")
                } else {
                    toast.error(data.msg);
                }
            })
            .catch((error) => {
                const { response } = error
                if (response) {
                    const { data } = response
                    if (response?.status == 401) {
                        toast.error("Please Login!");
                        logoutUser();
                    } else if (response?.status == 400) {
                        toast.error(data.msg);
                    } else {
                        toast.error(data.msg || "Request failed!");
                    }
                }
            })
            .finally((e) => {
                setIsLoading(false)
            });
    }

    const handleOnHide = () => {
        reset()
        setImagePreviewUrl(null)
        handleClose("manual")
    }

    return (
        upiActiveStatus != null && (
            <Modal show={show} onHide={handleOnHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Update UPI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(updateUpiSubmit)}>
                        <input type="text" {...register("upi")} hidden />
                        <input type="text" {...register("merchant")} hidden />

                        <div className="mb-3">
                            <label htmlFor='u-upi-name' className="form-label">UPI Name</label>
                            <input type="text" {...register("name")} className="form-control"
                                id="u-upi-name" />
                            <ValidationError name="name" errors={errors} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor='u-upi-vpa' className="form-label">UPI Id</label>
                            <input {...register("vpa")} type="text" className="form-control"
                                id="u-upi-vpa" />
                            <ValidationError name="vpa" errors={errors} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor='u-upi-active' className="form-label">Qr Code</label>
                            <div className="form-check form-switch">
                                <input {...register("staticQrCode")} value={staticQrCode} onChange={toggleStaticQrCode} className="form-check-input" type="checkbox"
                                    id="u-upi-active" checked={staticQrCode} />
                                <label className="form-check-label" htmlFor="u-upi-active">{staticQrCode ? "Upload Qr Code" : "Auto generat using UPI Id"}</label>
                            </div>
                            <ValidationError name="staticQrCode" errors={errors} />
                        </div>
                        {staticQrCode && (
                            <div className="mb-3">
                                <div className="container p-3 border rounded">
                                    <h6 className="form-label mb-3">Upload Qr Code</h6>
                                    <input type="file"
                                        onChange={handleFileChange}
                                        name="qrCodeImage"
                                        accept="image/jpeg, image/jpg, image/png, image/webp"
                                        multiple={false}
                                        className="form-control" id="upload-qrCodeImage" />
                                    {/* Image preview section */}
                                    {imagePreviewUrl && (
                                        <div className='mt-3'>
                                            <h6>Preview</h6>
                                            <div className='d-flex flex-column align-items-center'>
                                                <img
                                                    src={imagePreviewUrl}
                                                    alt="Image Preview"
                                                    style={{ maxWidth: '200px', maxHeight: '200px' }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <ValidationError name="qrCodeImage" errors={errors} />
                                </div>
                            </div>
                        )}

                        <div className="mb-3">
                            <label htmlFor='u-upi-active' className="form-label">Is Regex</label>
                            <div className="form-check form-switch">
                                <input {...register("isRegex")} value={regexStatus} onChange={toggleRegexStatus} className="form-check-input" type="checkbox"
                                    id="u-upi-active" checked={regexStatus} />
                                <label className="form-check-label" htmlFor="u-upi-active">{regexStatus ? "Enabled" : "Disabled"}</label>
                            </div>
                            <ValidationError name="isRegex" errors={errors} />
                        </div>
                        {regexStatus && getValues("regexPattern") != null && (
                            <div className="mb-3">
                                {/* <label htmlFor='c-upi-regexPattern' className="form-label">Regex Pattern</label> */}
                                {/* <input {...register("regexPattern")} type="text" className="form-control"
                                    id="c-upi-regexPattern" /> */}
                                <RegexInput onChange={(reg) => { setValue("regexPattern", reg); }} value={getValues("regexPattern")} />

                                <ValidationError name="regexPattern" errors={errors} />
                            </div>
                        )}

                        <div className="mb-3">
                            <label htmlFor='u-upi-active' className="form-label">Active</label>
                            <div className="form-check form-switch">
                                <input {...register("enabled")} value={upiActiveStatus} onChange={toggleActive} className="form-check-input" type="checkbox"
                                    id="u-upi-active" checked={upiActiveStatus} />
                                <label className="form-check-label" htmlFor="u-upi-active">UPI is {upiActiveStatus ? "Active" : "Inactive"}</label>
                            </div>
                            <ValidationError name="enabled" errors={errors} />
                        </div>

                        <button type="submit" className="btn btn-primary"
                            disabled={isLoading}>
                            {isLoading && (
                                <div className="spinner-border"></div>
                            )} Update
                        </button>
                    </form>
                </Modal.Body>
            </Modal>
        )
    )
}

export default UpdateUPIModal